import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/core/AuthContext';
import { useLanguage } from '@/core/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import { Button } from '@/shared/ui/button';
import { BrandIcon } from '@/shared/components/BrandIcon';
import { Mail, ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';

const CheckEmail = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  // If user somehow gets authenticated (e.g., email confirmation disabled), redirect to app
  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <BrandIcon className="h-9 w-9" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">Factory Pilot</h1>
          </div>
        </div>

        <Card className="shadow-elevated">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
              <Mail className="h-7 w-7 text-primary" />
            </div>
            <CardTitle>{t('auth.checkEmail.title', 'Check your email')}</CardTitle>
            <CardDescription className="text-base">
              {t('auth.checkEmail.description', 'We\'ve sent you a confirmation link. Please check your inbox and click the link to activate your account.')}
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-6">
            <div className="rounded-lg bg-muted/50 p-4 text-sm text-muted-foreground space-y-2">
              <p>{t('auth.checkEmail.tip1', 'The email may take a few minutes to arrive.')}</p>
              <p>{t('auth.checkEmail.tip2', 'Check your spam folder if you don\'t see it.')}</p>
            </div>

            <Button 
              asChild
              variant="outline"
              className="w-full"
            >
              <Link to="/auth">
                <ArrowLeft className="mr-2 h-4 w-4" />
                {t('auth.checkEmail.backToSignIn', 'Back to sign in')}
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CheckEmail;
